module.exports = __webpack_public_path__ + "images/pitpointac7d9a8d8b974263c4fbdd032dd2e88b.png";